module.exports = __webpack_public_path__ + "static/Toby_Scammell-770a752435add0256e0298b3c1f00b78.jpg";